/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'well-subscription-type-wizard',
  templateUrl: './subscription-type-wizard.component.html',
  styleUrls: ['./subscription-type-wizard.component.scss']
})
export class SubscriptionTypeWizardComponent {

  @Input() uuid: any;

  @Input() isEditMode = false;

  @Input() index = 0;

  constructor(private router: Router,  private activatedRoute: ActivatedRoute,) { }

  goToActionDefinitions(event: {uuid: string, next: boolean}) {
    if(event.next) {
      if(this.uuid === null || this.uuid !== event.uuid){
          this.router.navigate(['..', event.uuid], {relativeTo: this.activatedRoute, state: {index: 1}});
      }
      this.index = 1;
    }
  }

  onCancel() {
    this.router.navigate(['../'], {relativeTo: this.activatedRoute});
  }

  goToSubscriptions() {
      this.index = 2;
  }
}
